import { useState, useCallback } from 'react';
import { AiFeature } from '@tiendanube/common/src/enums';
import { useToast, useTranslationCommon } from 'commons/hooks';
import {
  trackingAiProductCategoryFeedbackPositiveClick,
  trackingAiProductCategoryFeedbackNegativeClick,
} from 'domains/Ai/tracking';

interface UseCategoriesFeedbackProps {
  runId?: string;
}

interface UseCategoriesFeedbackResult {
  showFeedbackModal: boolean;
  handlePositiveFeedback: () => void;
  handleNegativeFeedback: () => void;
  closeFeedbackModal: () => void;
}

function useCategoriesFeedback({
  runId,
}: UseCategoriesFeedbackProps): UseCategoriesFeedbackResult {
  const tCommon = useTranslationCommon();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const { addToast } = useToast();

  const handlePositiveFeedback = useCallback(() => {
    if (!runId) return;

    trackingAiProductCategoryFeedbackPositiveClick({
      feature: AiFeature.AI_PRODUCT_CATEGORY_SUGGESTIONS,
    });

    addToast({
      label: tCommon('aiFeedbackModal.tooltipThankYouMessage'),
      appearance: 'success',
    });
  }, [runId, addToast, tCommon]);

  const handleNegativeFeedback = useCallback(() => {
    trackingAiProductCategoryFeedbackNegativeClick({
      feature: AiFeature.AI_PRODUCT_CATEGORY_SUGGESTIONS,
    });
    setShowFeedbackModal(true);
  }, []);

  const closeFeedbackModal = useCallback(() => {
    setShowFeedbackModal(false);
  }, []);

  return {
    showFeedbackModal,
    handlePositiveFeedback,
    handleNegativeFeedback,
    closeFeedbackModal,
  };
}

export default useCategoriesFeedback;
